enum EndorsementSubmissionStatusReason {
	CALCULATION_REQUIRED = 'Calculation Required',
	MISSING_DATA = 'Missing Data',
	INVALID_DATA = 'Invalid Data',
}

export default EndorsementSubmissionStatusReason;